var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { useContext } from 'react';
import styled from 'styled-components';
var FormTextContext = React.createContext({});
var useFormTextContext = function (_a) {
    var suppressWarning = _a.suppressWarning, customError = _a.customError;
    var context = useContext(FormTextContext);
    // if any values are `undefined` we know that the hook is being used outside
    // of a FormTextProvider
    if ((context === null || context === void 0 ? void 0 : context.isFocused) === undefined && suppressWarning !== true) {
        throw new Error(customError ||
            'useFormTextContext must be consumed inside of a FormTextProvider');
    }
    return context;
};
var ComponentContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n"], ["\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n"])));
var FormTextProvider = function (_a) {
    var className = _a.className, children = _a.children, hasError = _a.hasError, isDisabled = _a.isDisabled, isFocused = _a.isFocused, isHovered = _a.isHovered, setFocused = _a.setFocused, setHovered = _a.setHovered, _b = _a.characterCounterWidth, characterCounterWidth = _b === void 0 ? 8 : _b;
    return (React.createElement(FormTextContext.Provider, { value: {
            isFocused: isFocused,
            isHovered: isHovered,
            hasError: hasError,
            isDisabled: isDisabled,
            characterCounterWidth: characterCounterWidth,
            setFocused: setFocused,
            setHovered: setHovered,
        } },
        React.createElement(ComponentContainer, { className: className }, children)));
};
export { FormTextProvider, FormTextContext, useFormTextContext, };
var templateObject_1;
//# sourceMappingURL=FormTextContext.js.map